exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.d-flex[data-v-147cf89c] {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n.item-thumbnail img[data-v-147cf89c] {\n    width: 50px;\n    height: 50px;\n    object-fit: cover;\n    cursor: pointer;\n}\n", ""]);

